export const duplicatePhonePolicyMessage =
  'This phone number is already linked to a Trini Rewards account. Each panelist needs their own phone number. Use a phone number that belongs only to your account, or email support@trinirewards.com if you believe this is a mistake.' as const;

export function normalizeTtMobileNumber(input: string): string {
  const digits = input.replace(/\D/g, '');
  const normalized =
    digits.length === 7
      ? `1868${digits}`
      : digits.length === 10 && digits.startsWith('868')
        ? `1${digits}`
        : digits;

  if (!/^1868\d{7}$/.test(normalized)) {
    throw new Error('tt_mobile_number_invalid');
  }

  return normalized;
}
